import PublicImage from 'src/common/components/PublicImage';
import { ResultsInterface } from '../../lib/type';
import { Button } from 'carbon-components-react';
import { ArrowRight20, WatsonHealthRotate_36020 } from '@carbon/icons-react';
import { useContext } from 'react';
import { layoutContext } from '../LeaderAssesssment';
import { Scenario } from '../../data/constants';

interface resultsProps {
  contents: ResultsInterface;
}

const LeaderResults = (resultsProps: resultsProps) => {
  const { contents } = resultsProps;
  const {
    setCurrentScenario,
    setCurrentQuestion,
    setSelectedOption,
    setOptionValeu,
    setScore,
    setSelectedAnswers,
  } = useContext(layoutContext);

  const restart = () => {
    setCurrentQuestion(1);
    setSelectedOption('');
    setOptionValeu(0);
    setScore(0);
    setCurrentScenario(Scenario.introduction);
    setSelectedAnswers([]);
  };

  return (
    <div className="leadership-assesssment__results bx--row">
      <div className="leadership-assesssment__results-content bx--col-lg-8">
        <div className="leadership-assesssment__results-content-text">
          <h1 className="leadership-assesssment__results-title bx--col-lg-14">
            {contents.resultsTitleLeader}
          </h1>
          <p className="leadership-assesssment__results-subtitle bx--col-lg-14">
            {contents.resultsTextLeader}
          </p>
          <ul className="leadership-assesssment__results-list-container">
            {contents.resultLeaderTips.map((teap) => {
              return (
                <li className="leadership-assesssment__results-list bx--col-lg-14">
                  <p className="leadership-assesssment__results-list-text">–</p>
                  <p className="leadership-assesssment__results-list-text">
                    {teap}
                  </p>
                </li>
              );
            })}
          </ul>
          <p className="leadership-assesssment__results-final-msg bx--col-lg-14">
            {contents.resultsFinalMsgLeader}
          </p>
        </div>
        <div className="leadership-assesssment__results-btn-container bx--col-sm-3">
          <Button
            className="leadership-assesssment__results-btn bx--btn"
            href="https://www.ibm.com/account/reg/us-en/signup?formid=urx-53231"
            target="_blank"
          >
            {contents.resultsDownloadBtn}
            <ArrowRight20 />
          </Button>
          <Button
            className="leadership-assesssment__results-btn bx--btn"
            href="https://www.ibm.com/account/reg/us-en/signup?formid=urx-52230"
            target="_blank"
            kind="tertiary"
          >
            {contents.resultsRestartBtn}
            <ArrowRight20 />
          </Button>
          <Button
            className="leadership-assesssment__results-btn bx--btn"
            kind="tertiary"
            onClick={() => restart()}
          >
            {contents.retryBtn}
            <WatsonHealthRotate_36020 />
          </Button>
        </div>
      </div>
      <div className="leadership-assesssment__results-container bx--col-lg-8">
        <PublicImage
          imgPath={contents.imageSrc}
          widgetId="leadership-assessment"
          alt={'alt'}
          className="leadership-assesssment__results-img"
        />
      </div>
    </div>
  );
};

export default LeaderResults;
